import React from 'react';
const links = [{
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Cookies',
  href: '#cookies'
}];
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-800/60" data-id="element-39">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10" data-id="element-40">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5" data-id="element-41">
          {/* Copyright */}
          <p className="text-slate-500 text-sm order-2 md:order-1" data-id="element-42">
            © {new Date().getFullYear()} Tu Marca. Todos los derechos
            reservados.
          </p>

          {/* Legal Links */}
          <nav className="flex items-center gap-6 md:gap-8 order-1 md:order-2" data-id="element-43">
            {links.map(link => <a key={link.label} href={link.href} className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200" data-id="element-44">
                {link.label}
              </a>)}
          </nav>
        </div>
      </div>
    </footer>;
}